"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/edit/24.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/trash-can/24.js"));
var _3 = _interopRequireDefault(require("@carbon/icons-react/lib/view/24.js"));
var _NumberFormatter = _interopRequireDefault(require("../../../../common/Formatters/NumberFormatter"));
var _CurrencyFormatter = _interopRequireDefault(require("../../../../common/Formatters/CurrencyFormatter"));
var _truncateString = require("../../../../common/truncateString.js");
var _headerColumns = _interopRequireDefault(require("./headerColumns"));
var _TableController = _interopRequireDefault(require("./TableController"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.employees-table .bx--data-table thead {\n  background: #e8e8e8;\n  border: none; }\n  .employees-table .bx--data-table thead th {\n    background: transparent;\n    padding: 1rem 1rem 0.5rem 0;\n    vertical-align: top; }\n    .employees-table .bx--data-table thead th:first-child {\n      padding-left: 1rem;\n      width: 15%; }\n    .employees-table .bx--data-table thead th:last-child {\n      width: 15%; }\n    .employees-table .bx--data-table thead th.number-alignment .bx--table-header-label {\n      text-align: right; }\n    .employees-table .bx--data-table thead th .bx--table-header-label {\n      color: #e41b13;\n      font-size: 12px; }\n    .employees-table .bx--data-table thead th button.bx--table-sort {\n      background: transparent; }\n      .employees-table .bx--data-table thead th button.bx--table-sort .bx--table-sort__icon-unsorted {\n        opacity: 1; }\n      .employees-table .bx--data-table thead th button.bx--table-sort .bx--table-sort__icon {\n        filter: invert(17%) sepia(55%) saturate(5926%) hue-rotate(354deg) brightness(94%) contrast(96%); }\n\n.employees-table .bx--data-table tr {\n  height: 20px; }\n  .employees-table .bx--data-table tr:first-child {\n    height: unset; }\n\n.employees-table .bx--data-table tbody {\n  background: transparent; }\n  .employees-table .bx--data-table tbody tr:first-child td {\n    border: none; }\n  .employees-table .bx--data-table tbody tr td {\n    border: none;\n    vertical-align: top;\n    background: #e8e8e8;\n    color: #4c4c4c;\n    border-top: 1px solid #fff;\n    padding: 0.5rem;\n    padding-top: 0.75rem;\n    padding-right: 1rem;\n    padding-left: 0;\n    width: fit-content; }\n    .employees-table .bx--data-table tbody tr td.number-alignment {\n      text-align: right; }\n    .employees-table .bx--data-table tbody tr td:first-child {\n      padding-left: 1rem;\n      white-space: nowrap;\n      width: 50px;\n      text-overflow: ellipsis; }\n    .employees-table .bx--data-table tbody tr td:last-child {\n      display: flex;\n      margin-left: 1rem;\n      padding: 0 0 1rem;\n      background: transparent;\n      justify-content: flex-end;\n      border: none; }\n      .employees-table .bx--data-table tbody tr td:last-child svg {\n        margin-left: 1rem;\n        float: left; }\n        .employees-table .bx--data-table tbody tr td:last-child svg:first-child {\n          margin-left: 0; }\n        .employees-table .bx--data-table tbody tr td:last-child svg:hover {\n          cursor: pointer;\n          transform: scale(1.1); }\n        .employees-table .bx--data-table tbody tr td:last-child svg.change {\n          margin-top: 1px; }\n    .employees-table .bx--data-table tbody tr td:hover {\n      cursor: pointer; }\n  .employees-table .bx--data-table tbody tr:hover {\n    background: transparent; }\n  .employees-table .bx--data-table tbody .actions {\n    display: flex; }\n";
  const fileName = "EmployeesTable_EmployeesTable";
  const element = document.querySelector("style[data-sass-component='EmployeesTable_EmployeesTable']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const tableStructure = new _TableController.default();
const defaultTableColumns = {
  id: '',
  nameOrNum: '',
  specXFunc: '',
  employmentGrade: '',
  yearOfBirth: '',
  grossSalary: '',
  absence: '',
  orderRelatedAttendance: '',
  nonOrderRelatedAttendance: '',
  remarks: ''
};
const EmployeesTable = _ref => {
  let {
    actions,
    items,
    className,
    translate
  } = _ref;
  const headerColumns = (0, _headerColumns.default)(translate);
  const tableItems = !items.length ? [defaultTableColumns] : tableStructure.getTableData(items);
  const hasActions = !items.length ? false : true;
  const carbonColumns = headerColumns.map(column => {
    return {
      key: column.name,
      header: column.label,
      class: column.class
    };
  });
  const renderActionIcon = (action, id) => {
    const minimumProps = {
      className: action.name,
      onClick: e => {
        e.stopPropagation();
        action.onClick(id);
      },
      key: `${id}-${action.name}`
    };
    switch (action.name) {
      case 'remove':
        return /*#__PURE__*/_react.default.createElement(_2.default, minimumProps);
      case 'change':
        return /*#__PURE__*/_react.default.createElement(_.default, minimumProps);
      case 'view':
        return /*#__PURE__*/_react.default.createElement(_3.default, minimumProps);
      default:
        return null;
    }
  };
  const createCellClasses = (column, cells) => {
    const cell = cells.filter(cell => cell.id.includes(column.name))[0];
    let isString = cell.value && !isNaN(cell.value);
    const classes = ['sia-text-09', isString ? 'number-alignment' : ''];
    if (column?.class) {
      classes.push(column.class);
    }
    return classes;
  };
  const relativeFormat = (str, col) => {
    if (col?.name.includes('remarks')) {
      return str;
    }
    if (col?.name.includes('grossSalary')) {
      return _CurrencyFormatter.default.formatAlternate(str, '');
    }
    return _NumberFormatter.default.format(str, true);
  };
  const renderCarbonTable = (carbonColumns, items) => {
    return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.DataTable, {
      rows: items,
      headers: carbonColumns
    }, _ref2 => {
      let {
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getTableProps
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Table, getTableProps(), /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableHead, null, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableRow, null, headers.map(header => {
        const currentColumnName = header.key;
        const column = headerColumns.find(column => column.name === currentColumnName);
        const classes = createCellClasses(column, rows[0].cells);
        return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableHeader, _extends({
          key: header.key
        }, getHeaderProps({
          header
        }), {
          className: classes.join(' ')
        }), header.header);
      }))), /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableBody, null, rows.map(row => {
        const rowAction = actions.filter(a => ['change', 'view'].includes(a.name))[0];
        return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableRow, _extends({
          onClick: () => rowAction.onClick(row.id),
          key: row.id
        }, getRowProps({
          row
        })), row.cells.map(cell => {
          const value = cell.value;
          const currentColumnName = cell.info.header;
          const column = headerColumns.find(column => column.name === currentColumnName);
          const classes = createCellClasses(column, rows[0].cells);
          if (column.name === 'nameOrNum') {
            return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableCell, {
              key: cell.id,
              className: classes.join(' ')
            }, (0, _truncateString.truncate)(value, 15));
          }
          return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableCell, {
            key: cell.id,
            className: classes.join(' ')
          }, !isNaN(value) ? (0, _truncateString.truncate)(relativeFormat(value, column), 15) : (0, _truncateString.truncate)(value, 13));
        }), /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TableCell, null, /*#__PURE__*/_react.default.createElement("div", {
          className: "actions"
        }, hasActions && actions.map(action => renderActionIcon(action, row.id)))));
      })));
    });
  };
  const classNames = ['employees-table', className ? className : null];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames.join(' ')
  }, renderCarbonTable(carbonColumns, tableItems));
};
EmployeesTable.propTypes = {
  actions: _propTypes.default.array.isRequired,
  items: _propTypes.default.array.isRequired,
  className: _propTypes.default.string,
  translate: _propTypes.default.func
};
var _default = exports.default = EmployeesTable;